import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from '@assets/icons/checkbox.svg';
const CustomChecboxIcon = () => {
    return (_jsx("img", { src: Checkbox, alt: "custom-checkbox-icon" }));
};
export default CustomChecboxIcon;
